import type { ReactNode } from 'react';
import { Button } from '../../design-system';
import { Modal } from './Modal';

/** Generic confirm dialog. `extra` renders between the message and the buttons. */
export function ConfirmModal({
  title,
  message,
  confirmLabel = 'Bevestigen',
  danger = false,
  busy = false,
  error,
  extra,
  onConfirm,
  onClose,
}: {
  title: string;
  message: string;
  confirmLabel?: string;
  danger?: boolean;
  busy?: boolean;
  error?: string;
  extra?: ReactNode;
  onConfirm: () => void;
  onClose: () => void;
}) {
  return (
    <Modal open onClose={onClose} title={title}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        <p style={{ margin: 0, fontSize: 14, color: '#444444' }}>{message}</p>
        {extra}
        {error && <div style={{ fontSize: 13, color: '#B0543B', fontWeight: 700 }}>{error}</div>}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <Button variant="ghost" type="button" onClick={onClose}>
            Annuleren
          </Button>
          <Button
            variant={danger ? 'accent' : 'primary'}
            type="button"
            onClick={onConfirm}
            disabled={busy}
          >
            {busy ? 'Bezig…' : confirmLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
